import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatIconModule } from '@angular/material/icon';
import { B2bDownloadConfirmationComponent } from './b2b-download-confirmation.component';

@NgModule({
  declarations: [B2bDownloadConfirmationComponent],
  imports: [CommonModule, FlexLayoutModule, RouterModule, MatIconModule],
  exports: [B2bDownloadConfirmationComponent],
})
export class B2bDownloadConfirmationModule {}
